<template>
  <ValidationObserver
    ref="descriptionFormObserver"
  >
    <div>
      <div
        v-for="(sample, index) in data.samples"
        :key="index"
      >
        <v-row>
          <v-btn
            v-if="data.samples.length > 1 && isSampleType(sampleTypes.COUPON)"
            icon
            :hidden="data.samples.length <= 1"
            :disabled="data.samples.length <= 1 || index === 0"
            @click="onClickRemoveSample(index)"
          >
            <v-icon>
              close
            </v-icon>
          </v-btn>
          <p class="titleModal mt-2 ml-3">
            {{ $t('forms.labels.sample') }} {{ index + 1 }}
          </p>
        </v-row>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            md="6"
            sm="12"
            xs="12"
            cols="12"
          >
            <VTextField
              v-model="sample.identification"
              outlined
              hideDetails
              :label="$t('forms.labels.identification')"
              readonly
              @change="updateData"
            />
          </v-col>
          <v-col
            md="6"
            sm="12"
            xs="12"
            cols="12"
          >
            <VDatePicker
              v-if="isSampleType(sampleTypes.COUPON)"
              v-model="sample.collectedDate"
              :label="$t('analysisRequests.labels.collectedDate') + ' *'"
              :locale="datePickerLocales[$store.getters.lang]"
              :rules="{ required: true }"
              outlined
              hideDetails
              data-cy="collectedDate-Description-AnalysisRequest"
              @input="onCollectedDateChanged($event, index, 'collectedDate')"
            />
            <VDateTimePicker
              v-else
              v-model="sample.collectedDate"
              :label="$t('analysisRequests.labels.collectedDate') + ' *'"
              :locale="datePickerLocales[$store.getters.lang]"
              outlined
              data-cy="collectedDate-Description-AnalysisRequest"
              @input="onCollectedDateChanged($event, index, 'collectedDate')"
            />
          </v-col>
        </v-row>
        <v-row
          align="center"
          justify="center"
          class="mt-8"
        >
          <v-col
            v-if="isSampleType(sampleTypes.COUPON)"
            class="py-0"
          >
            <VDatePicker
              v-model="sample.installedDate"
              :label="$t('analysisRequests.labels.installedDate')"
              :rules="{ required: true }"
              outlined
              data-cy="installedDate-Description-AnalysisRequest"
              @change="onCollectedDateChanged($event, index, 'installedDate')"
            />
          </v-col>
          <v-col
            v-if="isSampleType(sampleTypes.COUPON)"
            class="py-0"
          >
            <VTextField
              :value="daysInstalled(sample.installedDate, sample.collectedDate)"
              :label="$t('analysisRequests.labels.daysInstalled')"
              outlined
              readonly
              :rules="{ min_value: 0 }"
              @change="updateData"
            />
          </v-col>
        </v-row>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            v-if="isSampleType(sampleTypes.COUPON)"
            class="py-0"
          >
            <VAutocomplete
              v-model="sample.coupon"
              :label="$t('analysisRequests.labels.coupon')"
              :items="mutableValue.coupons"
              :rules="{ required: true }"
              outlined
              return-object
              data-cy="coupon-Description-AnalysisRequest"
              @change="updateData"
            />
          </v-col>
          <v-col
            v-if="isSampleType(sampleTypes.COUPON)"
            class="py-0"
          >
            <VTextField
              v-model="sample.code"
              :label="$t('analysisRequests.labels.couponCode')"
              outlined
              @change="updateData"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <VTextarea
              v-model="sample.comment"
              :label="$t('analysisRequests.labels.additionalInfo')"
              :rules="{ max: 50 }"
              outlined
              data-cy="comment-Description-AnalysisRequest"
              @change="updateData"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="data.samples.length === index + 1 && canAddMultipleSamples"
          class="mb-3"
        >
          <v-btn
            fab
            class="mx-2"
            xSmall
            color="#ef4135"
            @click="onClickAddSample"
          >
            <v-icon color="white">
              add
            </v-icon>
          </v-btn>
          <p

            class="titleModal mt-2"
          >
            {{ $t('forms.labels.sample') }} {{ index + 2 }}
          </p>
        </v-row>
      </div>
      <div>
        <WaterForm
          v-if="isSampleType(sampleTypes.WATER)"
          :analysisRequest="data"
          @updateData="updateDataType"
        />
        <LegionellosisForm
          v-if="isSampleType(sampleTypes.LEGIONELLOSIS)"
          :analysisRequest="data"
          :isTemplate="isTemplate"
          :tempratureUnits="tempratureUnits"
          @updateData="updateDataType"
        />
        <LegionellosisCultureForm
          v-if="isSampleType(sampleTypes.LEGIONELLA_CULTRURE)"
          :analysisRequest="data"
          :isTemplate="isTemplate"
          :tempratureUnits="tempratureUnits"
          @updateData="updateDataType"
        />
        <DepositForm
          v-if="isSampleType(sampleTypes.DEPOSIT)"
          :analysisRequest="data"
          @updateData="updateDataType"
        />
        <ContenanceForm
          v-if="isSampleType(sampleTypes.CONTENANCE)"
          :analysisRequest="data"
          :isEdition="isEdition"
          @updateData="updateDataType"
        />
        <ResinForm
          v-if="isSampleType(sampleTypes.RESIN)"
          :analysisRequest="data"
          :isEdition="isEdition"
          @updateData="updateDataType"
        />
        <CouponForm
          v-if="isSampleType(sampleTypes.COUPON)"
          :analysisRequest="data"
          @updateData="updateDataType"
        />
        <OtherForm
          v-if="isSampleType(sampleTypes.OTHER)"
          :analysisRequest="data"
          @updateData="updateDataType"
        />
        <GlycolForm
          v-if="isSampleType(sampleTypes.GLYCOL)"
          :analysisRequest="data"
          @updateData="updateDataType"
        />
        <p class="titleModal">
          {{ $t('forms.labels.note') }}
        </p>
        <VTextarea
          v-model="data.comment"
          outlined
          :label="$t('forms.labels.note')"
          :rules="{ max: 1000 }"
          @change="updateData"
        />
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import moment from 'moment-timezone';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker';
import VDateTimePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDateTimePicker';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

import sampleTypes from '@/constants/sampleTypes';

import WaterForm from '@/components/forms/sample/types/WaterForm';
import LegionellosisForm from '@/components/forms/sample/types/LegionellosisForm';
import LegionellosisCultureForm from '@/components/forms/sample/types/LegionellosisCultureForm';
import DepositForm from '@/components/forms/sample/types/DepositForm';
import ContenanceForm from '@/components/forms/sample/types/ContenanceForm';
import ResinForm from '@/components/forms/sample/types/ResinForm';
import CouponForm from '@/components/forms/sample/types/CouponForm';
import OtherForm from '@/components/forms/sample/types/OtherForm';
import GlycolForm from '@/components/forms/sample/types/GlycolForm';
import _datePickerLocales from '@/locales/date-picker-locales';
import units from '@/constants/tempratureUnits';
import { ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationObserver,
        VAutocomplete,
        VDatePicker,
        VDateTimePicker,
        VTextarea,
        VTextField,
        WaterForm,
        LegionellosisForm,
        LegionellosisCultureForm,
        DepositForm,
        ContenanceForm,
        ResinForm,
        CouponForm,
        OtherForm,
        GlycolForm,
    },
    props: {
        mutableValue: {
            type: Object,
            default: null,
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
        isTemplate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                type: '',
                samples: {},
                comment: '',
            },
        };
    },
    computed: {
        ...mapGetters([
            'getSample',
        ]),
        sampleTypes() {
            return sampleTypes;
        },
        site() {
            return this.getSample.site || null;
        },
        type() {
            return this.getSample.type;
        },
        daysInstalled() {
            return (installedDate, collectedDate) => {
                if (installedDate && collectedDate) {
                    //  as we only need the number of days we format the date and get the difference
                    return moment(collectedDate, 'YYYY-MM-DD').diff(moment(installedDate, 'YYYY-MM-DD'), 'days');
                }
                return '';
            };
        },
        datePickerLocales() {
            return _datePickerLocales;
        },
        tempratureUnits() {
            return Object.entries(units).map(([key, value]) => ({
                key,
                name: value,
            }));
        },
        canAddMultipleSamples() {
            return this.isSampleType(sampleTypes.COUPON) || this.isSampleType(sampleTypes.WATER) || this.isSampleType(sampleTypes.DEPOSIT);
        },
    },
    watch: {
        getSample: {
            handler() {
                this.data = cloneDeep(this.getSample);
                if (!this.getSample.site || this.isEdition || this.data?.samples?.length >= 1) {
                    return;
                }
                this.addSample();
            },
            immediate: true,
        },
    },
    mounted() {
        this.data.comment = this.getSample.comment;
    },
    methods: {
        onClickAddSample() {
            this.addSample();
        },
        async addSample() {
            if (!this.data.samples) this.data.samples = [];
            const identification = await this.generateSampleIdentification();
            this.data.samples.push({
                collectedDate: moment(new Date()).toISOString(),
                identification,
                comment: null,
            });
            this.updateData();
        },
        async generateSampleIdentification() {
            const { data } = await this.$rq.getSiteInfo(this.getSample.site);
            const deliveryAccountNumber = data.deliveryAccountNumber.substring(0, 3);
            const now = moment().format('YYMMDD');
            const id = this.$utils.generateRandomString(4).toUpperCase();
            return `${deliveryAccountNumber}-${now}-${id}`;
        },
        onClickRemoveSample(index) {
            this.data.samples.splice(index, 1);
        },
        updateDataType(e) {
            this.data = { ...this.data, ...e };
            this.updateData();
        },
        async updateData() {
            this.$emit('updateData', this.data);
            this.$emit('inputChange', this.$refs.descriptionFormObserver.validate);
        },
        isSampleType(type) {
            return this.getSample.type === type;
        },
        onCollectedDateChanged(value, index, key) {
            // since VDatePicker does not have the time attached, we need to add the current time manually
            const tz = moment.tz.guess();
            const collectedDate = moment(value).tz(tz).format();
            const date = moment(collectedDate).toISOString();

            this.data.samples[index] = {
                ...this.data.samples[index],
                [key]: date,
            };
            this.updateData();
        },
    },
};
</script>
